export default {
    disclaimer: {
        label_default: "Tudomásul veszem és elfogadom, hogy a megrendelt/fogadott tételek O-I tulajdonjogok, amelyeket O-I munkával kapcsolatos tevékenységekhez kell felhasználni, és mint ilyen, O-I fenntartja a jogot, hogy a O-I-ből való távozásomkor (vagy hamarabb, ha O-I ezt megköveteli) kérje a tulajdon visszaszolgáltatását.",
        label_type_1: "Megerősítem, hogy a házi feladattal kapcsolatos önértékelést pontosan és jóhiszeműen töltöttem ki, és a O-I helyszínről biztosított vagy a Gear-en keresztül megrendelt felszereléseket vagy bútorokat a O-I-lel végzett munkám céljából fogom használni. Tudomásul veszem és elfogadom, hogy a megrendelt/fogadott tételek O-I tulajdont képeznek, amelyet O-I munkával kapcsolatos tevékenységekhez kell használni, és mint ilyen, O-I fenntartja a jogot, hogy a O-I-ről való távozásomkor (vagy hamarabb, ha az O-I ezt megköveteli) kérje a tulajdon visszaszolgáltatását.",
        errors: {
            required: "Kérjük, fogadja el a felhasználási feltételeket"
        }
    },
    cost_center: {
        label: "Költségközpont kódja",
        placeholder: "Költségközpont kódja",
        cost_center_not_found: "A nem szereplő költségközpontok megjelenése akár 24 órát is igénybe vehet. Ha nem látja a megfelelő költségközpontot, forduljon a Globális Ügyfélszolgálathoz.",
        errors: {
            regex: "Érvénytelen költséghelykód"
        }
    },
    company_code: {
        label: "Cégkód"
    },
    cost_center_name: {
        label: "Költségközpont neve"
    },
    order_note: {
        label: "Rendelési megjegyzés",
        placeholder: "Opcionális megjegyzés a vezetőnek jóváhagyásra",
    },
    send_emails_to_oobo_orderer: {
        "OOBO": "Értesítsen a megrendelés frissítéseiről"
    },
    "dell_banner":{
        label: "A Dell rendszerfrissítések miatt a 2026. augusztus 1. és 14. között leadott Dell-rendelések feldolgozása jelentős késedelmeket tapasztalhat. Kérjük, számítson hosszabb teljesítési időre ebben az időszakban. Köszönjük megértését."
    }
}